var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-tooltip',{attrs:{"effect":"dark","content":"线上小平台订单","placement":"bottom-start"}},[_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.fetchList}},[_vm._v(" 新建订单 ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }